<template>
  <el-dialog
    width="648px"
    v-if="visible"
    :title="$t('certificate_staff_21')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form ref="form" class="form" :rules="rules" label-width="150px" :model="formData">
      <el-form-item :label="$t('certificate_official_13')" prop="name">
        <el-input clearable v-model="formData.name" :placeholder="$t('90')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('certificate_staff_17')" prop="type">
        <el-select v-model="formData.type" clearable :placeholder="$t('221')">
          <el-option :label="$t('certificate_module_15')" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('certificate_official_14')" prop="year">
        <el-date-picker
          class="picker"
          size="small"
          clearable
          v-model="formData.year"
          value-format="yyyy"
          type="year"
          :picker-options="pickerOptions"
          :placeholder="$t('837')"
        />
      </el-form-item>
      <el-form-item :label="$t('741')" prop="staff_data">
        <!-- 已选数量 -->
        <el-input
          @focus="openOrg"
          :value="$t('912', { y: formData.staff_list.length || 0, x: formData.department_list.length || 0 })"
        ></el-input>
        <organization
          v-if="orgVisible"
          @onConfirm="handleSelectDepart"
          :visible.sync="orgVisible"
          :defaultDepatment="formData.department_list"
          :defaultEmployess="formData.staff_list"
          isRegister="1"
        />
      </el-form-item>
      <!-- 发送时间 -->
      <el-form-item :label="$t('206')" prop="send_time">
        <el-date-picker
          popper-class="send-time"
          v-model="formData.send_time"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          size="small"
          :picker-options="pickerOptionsSend"
          :placeholder="$t('pay_slip_42')"
          :default-time="defaultTime"
          @change="handleSendTime"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('pay_slip_15')" prop="send_email_type">
        <el-select v-model="formData.send_email_type" :placeholder="$t('221')" clearable>
          <el-option :label="$t('personal_email')" value="1"></el-option>
          <el-option :label="$t('business_mailbox')" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('certificate_official_19')">
        <el-radio v-model="formData.is_supplement" label="1">{{ $t('532') }}</el-radio>
        <el-radio v-model="formData.is_supplement" label="2">{{ $t('578') }}</el-radio>
        <p v-if="formData.is_supplement === '1'">{{ $t('certificate_staff_26') }}</p>
        <p v-if="formData.is_supplement === '2'">{{ $t('certificate_module_16') }}</p>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">{{ $t('action.cancel') }}</el-button>
      <el-button type="primary" @click="handleSave" size="small">{{ $t('from_save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import { addTiming } from './config.js'
import organization from '_c/organization'
export default {
  components: { organization },
  data() {
    return {
      visible: false,
      formData: JSON.parse(JSON.stringify(addTiming.formData)),
      rules: addTiming.rules,
      orgVisible: false,
      defaultTime: '',
      pickerOptions: {
        // 只可选择当前年份及之前年份
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear()
        }
      },
      pickerOptionsSend: {
        // 当前系统时间+30分钟作为最早发送时间
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      }
    }
  },
  methods: {
    init(row) {
      this.formData = JSON.parse(JSON.stringify(addTiming.formData))
      if (row.id) {
        addTiming.formData.id = row.id
        this.formData = Object.assign(this.formData, row)
        this.formData.staff_data = [...this.formData.department_list, ...this.formData.staff_list]
        this.defaultTime = this.formData.send_time.split(' ')[1]
      }
      this.visible = true
    },
    handleSendTime() {
      this.handleDefaultTime(this.formData.send_time)
    },
    handleDefaultTime(newValue) {
      const time = new Date(newValue).getTime()
      const date = new Date().getTime() + 60 * 1000 * 30
      const nowDate = moment(date).format('yyyy-MM-DD HH:mm:ss')
      const dt = nowDate.split(' ')
      let st = newValue.split(' ')[1]
      if (newValue.split(' ')[0] === dt[0] && time < date) {
        // 是今天,选择 的时间开始为此刻的时分秒
        st = dt[1]
      }
      this.defaultTime = st
      this.formData.send_time = newValue.split(' ')[0] + ' ' + st
    },
    openOrg() {
      // 打开选择人员弹窗
      this.orgVisible = true
    },
    handleSelectDepart(params) {
      // 选择人员
      this.formData.department_list = params.dept_list
      this.formData.staff_list = params.staff_list
      this.formData.staff_data = [...params.dept_list, ...params.staff_list]
    },
    handleClose() {
      this.visible = false
      delete addTiming.formData.id
      this.formData = JSON.parse(JSON.stringify(addTiming.formData))
      this.$refs.form.clearValidate()
      this.$refs.form.resetFields()
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const staff_id = this.formateList(this.formData.staff_list, 'staff_id')
          const department_list = this.formateList(this.formData.department_list, 'department_id')
          const data = {
            name: this.formData.name,
            type: this.formData.type,
            year: this.formData.year,
            send_time: this.formData.send_time,
            send_email_type: this.formData.send_email_type,
            is_supplement: this.formData.is_supplement,
            staff_id: staff_id.length ? staff_id : '',
            department_id: department_list.length ? department_list : ''
          }
          if (this.formData.id) data.id = this.formData.id
          this.$emit('handleSave', data)
        }
      })
    },
    formateList(obj, key) {
      // 数据格式化
      return obj.map(item => item[key])
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  .tip {
    font-size: 14px;
    color: #8c8c8c;
  }
}
/deep/ .el-input,
.el-select {
  width: 360px;
  max-width: 360px;
}
</style>
